import {useEffect, useState} from "react";

const useDeviceDetection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktopModeOnMobile, setIsDesktopModeOnMobile] = useState(false);
  const [screenWidth, setScreenWidth] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent || (window as any).opera;
      const isMobileUA = /android|iphone|ipad|ipod|windows phone/i.test(
        userAgent
      );

      const handleResize = () => {
        setScreenWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);
      setScreenWidth(window.innerWidth); // Set the initial screen width

      setIsMobile(isMobileUA);

      if (isMobileUA && screenWidth > 768) {
        setIsDesktopModeOnMobile(true);
      } else {
        setIsDesktopModeOnMobile(false);
      }

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [screenWidth]);

  return {isMobile, isDesktopModeOnMobile};
};

export default useDeviceDetection;
